import { type RefObject, useEffect, useState } from 'react';

export function useHasScroll<T extends HTMLElement = HTMLElement>(ref: RefObject<T | null>) {
    const [hasScroll, setHasScroll] = useState(false);

    useEffect(() => {
        const target = ref.current;
        if (!target) {
            return;
        }
        const checkScroll = () => {
            setHasScroll(target.scrollHeight > target.clientHeight);
        };

        const resizeObserver = new ResizeObserver(checkScroll);
        resizeObserver.observe(target);

        checkScroll();

        return () => {
            resizeObserver.disconnect();
        };
    }, [ref]);

    return hasScroll;
}
